module.exports = __webpack_public_path__ + "img/whszlcx.09c6ab86.png";